import { loadLs, saveLs } from '../../../storage/localStorage';
import { orderData, setReturnTripOrderData } from '../orderData';
import { renderPriceInfo } from '../step2/utils/renderPriceInfo';
import { tripData } from './trip-form';
import { changeBgColor, changeInputsStyled } from './utils/changeInputsStyled';

// =====================================
// Селектори
// =====================================
const refs = {
  returnTripCheckbox: document.getElementById('return-trip'),
  returnTripTimeWrapper: document.getElementById('return-trip-time-wrapper'),
  returnTripTimeInput: document.getElementById('return-trip_time'),
};
const { returnTripCheckbox, returnTripTimeWrapper, returnTripTimeInput } = refs;

// =====================================
// Початкові дані returnTripData
// =====================================
const initialReturnTripData = {
  returnTrip: false,
  returnTripTime: null,
};

let returnTripData = { ...initialReturnTripData };

// =====================================
// Функція оновлення даних returnTripData і збереження в localStorage
// =====================================
const setReturnTripData = data => {
  Object.assign(returnTripData, data);
  setReturnTripOrderData(returnTripData);
  saveLs(keyLS, returnTripData);
};

const keyLS = 'returnTripData';
// =====================================
// Відновлення returnTripData з localStorage при завантаженні сторінки
// =====================================
const savedReturnTripData = loadLs(keyLS);
if (savedReturnTripData) {
  returnTripData = { ...initialReturnTripData, ...savedReturnTripData };
  setReturnTripOrderData(returnTripData);

  // Відновлення стану чекбокса і поля часу повернення (лише якщо елементи існують)
  if (returnTripCheckbox && returnTripTimeWrapper && returnTripTimeInput) {
    if (returnTripData.returnTrip) {
      returnTripCheckbox.checked = true;
      returnTripTimeWrapper.style.display = 'block';
      returnTripTimeInput.required = true;
      if (returnTripData.returnTripTime) {
        // Перевіряємо дату, якщо вона в минулому - не відновлюємо і очистимо
        if (
          new Date(returnTripData.returnTripTime.replace(' ', 'T')).getTime() <
          (tripData.time
            ? new Date(tripData.time.replace(' ', 'T')).getTime()
            : new Date().getTime())
        ) {
          setReturnTripData({ returnTripTime: null });
        } else {
          returnTripTimeInput.value = returnTripData.returnTripTime;
          changeInputsStyled(returnTripTimeInput, true);
        }
      }
    } else {
      returnTripCheckbox.checked = false;
      returnTripTimeWrapper.style.display = 'none';
      returnTripTimeInput.required = false;
    }
  }
}

// =====================================
// Слухач checkbox id="return-trip"
// =====================================
returnTripCheckbox?.addEventListener('change', e => {
  if (!returnTripTimeWrapper || !returnTripTimeInput) return;
  const isChecked = e.target.checked;
  if (isChecked) {
    setReturnTripData({ returnTrip: true });
    returnTripTimeWrapper.style.display = 'block';
    returnTripTimeInput.required = true;
    // Ставимо час для повернення не раніше ніж годину після замовлення туди (tripData.time + 1 година)
    const minReturnTime = orderData.trip.time
      ? new Date(orderData.trip.time.replace(' ', 'T'))
      : new Date();
    if (minReturnTime) {
      minReturnTime.setHours(minReturnTime.getHours() + 1);
      returnTripTimeInput._flatpickr?.set?.('minDate', minReturnTime);
    }

    renderPriceInfo(); // оновлюємо ціну в кроці 2
  } else {
    setReturnTripData({
      returnTrip: false,
      returnTripTime: null,
    }); // очищуємо час повернення при відключенні чекбокса
    renderPriceInfo(); // оновлюємо ціну в кроці 2
    returnTripTimeWrapper.style.display = 'none';
    returnTripTimeInput.required = false;
    returnTripTimeInput._flatpickr?.clear?.();
    changeBgColor(returnTripTimeInput, '#fff');
  }
});

// =====================================
// Слухач input id="return-trip_time"
// =====================================
returnTripTimeInput?.addEventListener('input', e => {
  const value = e.target.value;
  changeInputsStyled(returnTripTimeInput, value);
  if (value) {
    setReturnTripData({ returnTripTime: value });
  } else {
    setReturnTripData({ returnTripTime: null });
  }
});

// =====================================
// Функція скидання returnTripData до початкових значень
// =====================================
export const resetReturnTripData = () => {
  returnTripData = { ...initialReturnTripData };
  setReturnTripOrderData(returnTripData);
  saveLs(keyLS, returnTripData);
  if (returnTripCheckbox) returnTripCheckbox.checked = false;
  if (returnTripTimeWrapper) returnTripTimeWrapper.style.display = 'none';
  if (returnTripTimeInput) {
    returnTripTimeInput.required = false;
    returnTripTimeInput.value = '';
    changeInputsStyled(returnTripTimeInput, false);
  }
};
